import { useState, useCallback, useRef } from 'react'
import { api } from '../api/client.js'

export function useFeedback(me, role, selectedSessionId) {
  const [feedbackOpen, setFeedbackOpen] = useState(false)
  const contextRef = useRef(null)

  const openFeedbackModal = useCallback(() => {
    contextRef.current = {
      userName: me?.name || '',
      userEmail: me?.email || '',
      userRole: role || '',
      userId: me?.userId || '',
      currentPage: window.location.pathname,
      meetingId: selectedSessionId || null,
      userAgent: navigator.userAgent,
      submittedAt: new Date().toISOString(),
    }
    setFeedbackOpen(true)
  }, [me, role, selectedSessionId])

  const closeFeedbackModal = useCallback(() => {
    setFeedbackOpen(false)
  }, [])

  const submitFeedback = useCallback(async (type, subject, description) => {
    return api.submitFeedback({
      type,
      subject,
      description,
      context: contextRef.current,
    })
  }, [])

  return {
    feedbackOpen,
    openFeedbackModal,
    closeFeedbackModal,
    submitFeedback,
  }
}
